import * as yup from '@cld/yup-extra';

export const assetBaseSchema = yup
  .object({
    publicId: yup.string().required(),
    filename: yup.string().required(),
    format: yup.string().required(),
    bytes: yup.number().required(),
    urls: yup
      .object({
        original: yup.string().required(),
        originalDownload: yup.string().required(),
        preview: yup.string().required(),
        thumbnail: yup.string().required(),
      })
      .required(),
  })
  .required();

export type AssetBase = yup.InferType<typeof assetBaseSchema>;